import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

const OptionAnalytic = ({data}) => {
  if (!data || data.length === 0 || !data[0].questions || data[0].questions.length === 0) {
    return null; // or render some error message
  }
  const transformData = (options) => {
    const chartData = options.map((option, index) => ({
      name: option.option,
      value: parseInt(option.chosenBy)
    }));

    return chartData;
  };

  return (
    <Box>
      {data.map((item, index) => (
        <Box key={index} display={{ base: "flex", md: "grid" }} flexDir={"column"} gridTemplateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gridGap={5} ml={{ md: "10" }}>
          {item.questions.map((question, qIndex) => (
            <Box key={qIndex} >
              <Text mb="5" textAlign={{ base: "center", md: "left" }}>{qIndex+1}. {question.questionText}</Text>
              <BarChart width={400} height={200} data={transformData(question.options)}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="value" fill="#8884d8" />
              </BarChart>
            </Box>
          ))}
        </Box>
      ))}
    </Box>
  );
};

export default OptionAnalytic;
